module.exports = __webpack_public_path__ + "img/3.927dd96.jpg";